<template>
  <b-carousel
    class="trails-carousel"
    :interval="6000"
    img-width="1024"
    img-height="480"
    indicators
  >
    <b-carousel-slide
      v-if="activeTrail"
      :img-src="activeTrail.image || defaultBgImage"
    >
      <a :href="activeTrail.link">
        <span class="d-block small mb-2 text-uppercase text-muted">
          Learning Trail
        </span>
        <span class="h3 d-block mb-auto">{{ activeTrail.title }}</span>
        <span class="d-block">{{ activeTrail.description }}</span>
      </a>
    </b-carousel-slide>
    <b-carousel-slide
      v-for="trail in trails"
      v-bind:key="trail.id"
      :img-src="trail.image || defaultBgImage"
    >
      <a :href="trail.link">
        <span class="d-block small mb-2 text-uppercase text-muted">
          Learning Trail
        </span>
        <span class="h3 mb-auto d-none d-lg-block">{{ trail.title }}</span>
        <span class="h4 mb-auto d-block d-lg-none">{{ trail.title }}</span>
        <span class="d-block">{{ trail.description }}</span>
      </a>
    </b-carousel-slide>
  </b-carousel>
</template>

<style lang="scss">
  .trails-carousel {
    .carousel-caption {
      left: 0;
      right: 0;
      bottom: 0;
      top: 0;
      width: 100%;
      border-radius: 4px;
      background-image: linear-gradient(
          rgba(0, 0, 0, 0.25),
          rgba(0, 0, 0, 0),
          rgba(0, 0, 0, 0.25)
      );

      a {
        left: 0;
        right: 0;
        bottom: 0;
        top: 0;
        width: 100%;
        position: absolute;
        text-decoration: none;
        color: #fff;
        display: flex;
        justify-content: space-between;
        flex-direction: column;
        padding: 1.25rem 1.25rem 50px;
        text-align: left;
      }
    }

    .carousel-item > img {
      border-radius: 4px;
    }

    .carousel-indicators {
      right: auto;
      margin-left: 1.25rem;
    }
  }
</style>

<script>
export default {
  props: {
    activeTrail: {
      type: Object,
      default () {
        return null
      }
    },
    trails: {
      type: Array,
      required: true
    },
    defaultBgImage: {
      type: String,
      required: true
    }
  }
}
</script>
